export const EDFLEX_ROUTING = {
  formations: 'formations',
  tabSlug: ':tabSlug',
} as const;
